import { render } from "./PurchaseSale.vue?vue&type=template&id=2d91d180&scoped=true"
import script from "./PurchaseSale.vue?vue&type=script&lang=js"
export * from "./PurchaseSale.vue?vue&type=script&lang=js"

import "./PurchaseSale.vue?vue&type=style&index=0&id=2d91d180&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d91d180"]])

export default __exports__